// AI Chat service that uses Gherbal API backend
import { reportData } from "./reportProcessor";

// API endpoint for Gherbal AI chat
const API_CHAT_URL = "https://gherbal-gpt.gherbal.workers.dev/api/chat";

// Function to get AI response using Gherbal API
export const getAIResponse = async (userMessage, language = "en") => {
  try {
    const response = await fetch(API_CHAT_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        message: userMessage,
        language: language || "en",
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error("Gherbal API Error:", errorData);
      throw new Error(
        `Gherbal API Error: ${
          errorData.error || errorData.message || "Unknown error"
        }`
      );
    }

    const data = await response.json();
    return (
      data.response || data.message || "Sorry, I couldn't generate a response."
    );
  } catch (error) {
    console.error("AI Response Error:", error);

    // Fallback to local processing if AI fails
    const { generateResponse } = await import("./reportProcessor");
    return generateResponse(userMessage, language);
  }
};

export default { getAIResponse };
